import MissingCompetenciesView from './MissingCompetenciesView';
export default MissingCompetenciesView;